import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getGroupVendors = ({ groupId }) =>
  call(websocketFetch, 'get_group_vendors', {
    group_id: groupId,
  });
